import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect, useState } from "react";
import Encuesta1 from "../../../assets/img/Encuesta1.svg";
import Encuesta2 from "../../../assets/img/Encuesta2.svg";
import Encuesta3 from "../../../assets/img/Encuesta3.svg";
import Encuesta4 from "../../../assets/img/Encuesta4.svg";
import Encuesta5 from "../../../assets/img/Encuesta5.svg";
import ButtonZegel from "../../../components/Buttons/ButtonZegel";
import DialogZegel from "../../../components/Dialog/DialogZegel";
import useAlumno from "../../../hooks/useAlumno";
import { ActualizarEncuestaPersonaPrograma, RegistrarEncuestaPersonaPrograma } from "../../../services/CursoService";
import "./style/EncuestaPrograma.scss";

function EncuastaPrograma({
  mostrarEncuestas,
  idEncuestas,
  Persona,
  programa,
  listaProgresoLeccionUnidadeCursoPrograma,
  listaLeccionUnidadeCursoPrograma,
  listaEvaluacionesUnidadeCursoPrograma,
  listaUnidadeCursoPrograma,
  listaCursoPrograma,
}) {
  const { perfil, configuraciones, activosChecked, setActivosChecked, finalizadoChecked
    , setFinalizadoChecked, explorarChecked, setExplorarChecked, indexActiveCursos, setIndexActiveCursos } = useAlumno();
  /*Encuestas */



  const [showAlertEncuesta1, setShowAlertEncuesta1] = useState(false);

  const [NumeradorPantallaDialogAbierta, setNumeradorPantallaDialogAbierta] = useState(1);
  const [showAlertValoracionPlataforma, setShowAlertValoracionPlataforma] = useState(null);
  const [selectedButtonEncuetas1, setSelectedButtonEncuetas1] = useState(null);
  const [BtonDisableEncuesta1, setBtonDisableEncuesta1] = useState(true);
  const [textareaEncuesta1Value, settextareaEncuesta1Value] = useState("");

  const [showAlertEncuestaFinal, setShowAlertEncuestaFinal] = useState(false);
  const [contenidoEncuesta, setContenidoEncuesta] = useState(null);
  const [showAlertRecomendacionCurso, setshowAlertRecomendacionCurso] = useState(false);
  const [BtonDisableEncuesta4, setBtonDisableEncuesta4] = useState(true);
  const [selectedButtonEncuesta4, setSelectedButtonEncuesta4] = useState(null);
  const [selectedButtonEncuetas5, setSelectedButtonEncuetas5] = useState(null);
  const [textareaEncuesta5Value, settextareaEncuesta5Value] = useState("");
  const [selectedButtonEncuetas6, setSelectedButtonEncuetas6] = useState(null);
  const [textareaEncuesta6Value, settextareaEncuesta6Value] = useState("");
  const [showAlertRecomendacionCursoDialog5, setshowAlertRecomendacionCursoDialog5] = useState(false);
  const [showAlertRecomendacionCursoDialog6, setshowAlertRecomendacionCursoDialog6] = useState(false);
  const [nombremodulos, setnombremodulos] = useState(null);
  const [selecciones, setSelecciones] = useState([]);
  /*Encuestas */

  useEffect(() => {
    setnombremodulos(listaCursoPrograma);
    if (idEncuestas == 1) {
      setShowAlertEncuesta1(true);
      setNumeradorPantallaDialogAbierta(1);
    }
    if (idEncuestas == 2) {
      setShowAlertEncuestaFinal(true);
      setNumeradorPantallaDialogAbierta(3);

    }
  }, [idEncuestas, listaCursoPrograma]);




  const handleRadioChange = (i, value) => {
    const newSelecciones = [...selecciones];
    newSelecciones[i] = value;
    setSelecciones(newSelecciones);
    if (newSelecciones.length == listaCursoPrograma.length) {
      setBtonDisableEncuesta4(false)
    }
  };

  //Pantalla dialogo 1  
  const encuesta = (

    <div>
      <span>
        <strong>¡Sigue así! Vas a la mitad del programa de especialización</strong>
      </span>
      <br></br>
      <span>
        {/* <strong>{curso && curso.nombre}</strong> */}
        <strong>"{programa && programa.nombre}"</strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Queremos brindarte una buena experiencia dentro de la plataforma,
        ayúdanos respondiendo la siguiente pregunta.
      </span>
      <br></br>
      <br></br>
      <span>
        <strong>{"No te tomará más de 1 minuto. "}</strong>
        Muchas gracias.
      </span>
    </div>
  );

  const footerEncuesta = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Valorar programa"
          color="primary-2"
          onClick={() => EncuestaValidarCurso()}
        ></ButtonZegel>
      </div>
    </>
  );

  function EncuestaValidarCurso() {
    if (NumeradorPantallaDialogAbierta == 3) {
      setshowAlertRecomendacionCurso(true);
      setShowAlertEncuestaFinal(false);
      setNumeradorPantallaDialogAbierta(4);
    }
    if (NumeradorPantallaDialogAbierta == 1) {
      setShowAlertValoracionPlataforma(true);
      setShowAlertEncuesta1(false);
      setNumeradorPantallaDialogAbierta(2);
    }
  }
  const handleButtonClickValoracionPlataforma = (buttonIndex) => {
    setBtonDisableEncuesta1(false);
    setSelectedButtonEncuetas1(buttonIndex);
  };
  // pantalla dialog 2
  const valoracionPlataforma = (
    <div>
      <span>
        <strong>Hasta el momento</strong>
      </span>
      <br></br>
      <span>
        <strong>¿Qué tal te parece la navegación en la plataforma?</strong>
      </span>
      <br></br>
      <br></br>
      <div className="p-fluid formgrid grid">
        <div className=" col-3 md:col-2 boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 1
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(1)}
          >
            <img src={Encuesta2} alt="" />
            <span style={{ fontSize: "12px" }}>Muy difícil</span>
          </button>
        </div>
        <div className=" col-3 md:col-2 boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 2
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(2)}
          >
            <img src={Encuesta3} alt="" />
            <span style={{ fontSize: "12px" }}>Difícil</span>
          </button>
        </div>
        <div className=" col-3 md:col-2 boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 3
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(3)}
          >
            <img src={Encuesta4} alt="" />
            <span style={{ fontSize: "12px" }}>Regular</span>
          </button>
        </div>
        <div className=" col-3 md:col-2 boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 4
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(4)}
          >
            <img src={Encuesta1} alt="" />
            <span style={{ fontSize: "12px" }}>Fácil</span>
          </button>
        </div>
        <div className=" col-3 md:col-2 boton-evaluacion-plataforma">
          <button
            className={`boton ${selectedButtonEncuetas1 === 5
              ? "seleccionado boton-con-imagen"
              : "boton-con-imagen"
              }`}
            onClick={() => handleButtonClickValoracionPlataforma(5)}
          >
            <img src={Encuesta5} alt="" />
            <span style={{ fontSize: "12px" }}>Muy fácil</span>
          </button>
        </div>
        <br></br>
      </div>
      <div style={{ textAlign: "initial" }}>
        <span>
          <strong>Cuéntanos tu experiencia (Opcional)</strong>
        </span>
      </div>
      <br></br>
      <InputTextarea
        placeholder="Escribe un comentario…"
        rows={5}
        cols={30}
        style={{ width: "100%" }}
        value={textareaEncuesta1Value}
        onChange={(e) => settextareaEncuesta1Value(e.target.value)}
      />
    </div>
  );

  const footerValoracionPlataforma = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          disabled={BtonDisableEncuesta1}
          label="Enviar"
          color="primary-2"
          onClick={() => { enviarEncuesta1() }}
        ></ButtonZegel>
      </div>
    </>
  );
  const enviarEncuesta1 = () => {
    

    let IdPersonaPrograma = listaCursoPrograma[0].idPersonaPrograma;
    let PrimerEncuestaProgramaRealizada = true;
    let PrimerEncuestaProgramaResultado = selectedButtonEncuetas1;
    let PrimerEncuestaProgramaComentario = textareaEncuesta1Value;
    let encuestaprograma = JSON.stringify({
      IdPersonaPrograma,
      PrimerEncuestaProgramaRealizada,
      PrimerEncuestaProgramaResultado,
      PrimerEncuestaProgramaComentario,
    });
    let jwt = window.localStorage.getItem("jwt");
    RegistrarEncuestaPersonaPrograma({ encuestaprograma, jwt }).then((data) => {
      setShowAlertValoracionPlataforma(false);
    });
  };

  const footerRecomendacionPlataforma = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          disabled={BtonDisableEncuesta4}
          label="Continuar"
          color="primary-2"
          onClick={() => {
            enviarEncuesta2();
          }}
        ></ButtonZegel>
      </div>
    </>
  );
  const footerEnviarFinal = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          disabled={BtonDisableEncuesta4}
          label="Enviar y dirigirme a mi progreso"
          color="primary-2"
          onClick={() => {
            enviarEncuesta2();
          }}
        ></ButtonZegel>
      </div>
    </>
  );

  const enviarEncuesta2 = () => {
    if (NumeradorPantallaDialogAbierta == 5) {
      let IdPersonaPrograma = listaCursoPrograma[0].idPersonaPrograma;
      let SegundaEncuestaProgramaRealizada = true;
      let SegundaEncuestaProgramaResultado1 = selectedButtonEncuesta4;
      let SegundaEncuestaProgramaResultado2 = selecciones.join(',');;
      let SegundaEncuestaProgramaComentarioResultado2 = textareaEncuesta5Value;
      let jwt = window.localStorage.getItem("jwt");

      let encuestaprograma = JSON.stringify({
        IdPersonaPrograma,
        SegundaEncuestaProgramaRealizada,
        SegundaEncuestaProgramaResultado1,
        SegundaEncuestaProgramaResultado2,
        SegundaEncuestaProgramaComentarioResultado2,
      });
      ActualizarEncuestaPersonaPrograma({ encuestaprograma, jwt }).then((data) => {
        setNumeradorPantallaDialogAbierta(0);
        setshowAlertRecomendacionCursoDialog5(false);
      });
    }

    if (NumeradorPantallaDialogAbierta == 4) {
      setshowAlertRecomendacionCurso(false);
      setshowAlertRecomendacionCursoDialog5(true);
      setBtonDisableEncuesta4(true);
      setNumeradorPantallaDialogAbierta(5);
    }
  };

  // pantalla dialog 3
  const encuestaFinalizado = (
    <div>
      <span style={{ fontSize: "18px" }}>
        <strong>¡Felicitaciones {perfil && perfil.nombres}!</strong>
      </span>
      <br></br>
      <br></br>
      <span>
        Puedes descargar tu certificado del programa "{programa && programa.nombre}" en la
        sección “Mi progreso”.
      </span>
      <br></br>
      <br></br>
      <span>
        Queremos brindarte un excelente servicio educativo, ayúdanos
        respondiendo 3 preguntas.
        <strong>{" No te tomará más de 2 minutos. "}</strong>
      </span>
    </div>
  );
  const handleButtonClickEncuesta4 = (buttonIndex) => {
    setSelectedButtonEncuesta4(buttonIndex);
    setBtonDisableEncuesta4(false);
  };
  const firstRowNumbers = [0, 1, 2, 3, 4, 5];
  const secondRowNumbers = [6, 7, 8, 9, 10];
  // pantalla dialog 4
  const recomendacionCurso = (
    <>
      <div>
        <span>
          <strong>¿Recomendarías este programa de especialización?</strong>
        </span>
        <br></br>
        <br></br>
        <span>Donde 0 es menos recomendable y 10 es muy recomendable.</span>
        <br></br>
        <br></br>
        <div className="botones-container-encuesta4">
          <div className="botones-row">
            {firstRowNumbers.map((number) => (
              <button
                key={number}
                className={`boton-encuesta4 ${selectedButtonEncuesta4 === number
                  ? "seleccionado-encuesta4"
                  : ""
                  }`}
                onClick={() => handleButtonClickEncuesta4(number)}
              >
                {number}
              </button>
            ))}
          </div>
          <div className="botones-row">
            {secondRowNumbers.map((number) => (
              <button
                key={number}
                className={`boton-encuesta4 ${selectedButtonEncuesta4 === number
                  ? "seleccionado-encuesta4"
                  : ""
                  }`}
                onClick={() => handleButtonClickEncuesta4(number)}
              >
                {number}
              </button>
            ))}
          </div>
        </div>
        <br></br>
      </div>
    </>
  );
  const handleButtonClickEncuetas5 = (buttonIndex) => {
    setBtonDisableEncuesta4(false);
    setSelectedButtonEncuetas5(buttonIndex);
  };
  // pantalla dialog 5
  const recomendacionCursoDialogo5 = (
    <>
      <div>
        <span>
          <strong>
            ¿Cuál fue el módulo que más te gustó y el que menos te gustó?
          </strong>
        </span>
        <br></br>
        <br></br>
        <span>
          Califica los módulos en una escala del 1 al 5, donde 1 es que no te gustó y 5 que te gustó.
        </span>
        <br></br>
        <br></br>

        <div className="p-fluid formgrid grid">
          <div className=" col-5">

          </div>
          <div className=" col-7">
            1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2 &nbsp;&nbsp;&nbsp;&nbsp; 3 &nbsp;&nbsp;&nbsp;&nbsp; 4 &nbsp;&nbsp;&nbsp;&nbsp; 5&nbsp;&nbsp;&nbsp;
          </div>
        </div>

        {nombremodulos && nombremodulos.map((item, i) => (
          <div>
            <div className="p-fluid formgrid grid">
              <div className=" col-5" style={{ textAlign: "left" }}>
                {item.curso.nombre}
              </div>
              <div className=" col-7 radio-buttons flex align-items-center justify-content-center" >
                <label><input type="radio" name={`radio_${i}`} value="1" onChange={() => handleRadioChange(i, 1)} /></label>
                <label><input type="radio" name={`radio_${i}`} value="2" onChange={() => handleRadioChange(i, 2)} /></label>
                <label><input type="radio" name={`radio_${i}`} value="3" onChange={() => handleRadioChange(i, 3)} /></label>
                <label><input type="radio" name={`radio_${i}`} value="4" onChange={() => handleRadioChange(i, 4)} /></label>
                <label><input type="radio" name={`radio_${i}`} value="5" onChange={() => handleRadioChange(i, 5)} /></label>
              </div>
            </div>
            <br></br>
          </div>
        ))}
        <br></br>
      </div>
      <div style={{ textAlign: "initial" }}>
        <span>
          <strong>Cuéntanos ¿Qué te pareció este programa? (Opcional)</strong>
        </span>
      </div>
      <br></br>
      <InputTextarea
        placeholder="Escribe un comentario…"
        rows={5}
        cols={30}
        style={{ width: "100%" }}
        value={textareaEncuesta5Value}
        onChange={(e) => settextareaEncuesta5Value(e.target.value)}
      />
    </>
  );

  return (
    <div>
      <DialogZegel
        header=""
        visible={mostrarEncuestas && showAlertEncuesta1}
        width="30vw"
        onHide={() => setShowAlertEncuesta1(false)}
        footer={footerEncuesta}
        contenido={encuesta}
        textAlign="center"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertEncuestaFinal}
        width="30vw"
        onHide={() => setShowAlertEncuestaFinal(false)}
        footer={footerEncuesta}
        contenido={encuestaFinalizado}
        textAlign="center"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertValoracionPlataforma}
        width="40vw"
        onHide={() => setShowAlertValoracionPlataforma(false)}
        footer={footerValoracionPlataforma}
        contenido={valoracionPlataforma}
        textAlign="left"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertRecomendacionCurso}
        width="35vw"
        onHide={() => setshowAlertRecomendacionCurso(false)}
        footer={footerRecomendacionPlataforma}
        contenido={recomendacionCurso}
        textAlign="left"
      ></DialogZegel>
      <DialogZegel
        header=""
        visible={showAlertRecomendacionCursoDialog5}
        width="35vw"
        onHide={() => setshowAlertRecomendacionCursoDialog5(false)}
        footer={footerEnviarFinal}
        contenido={recomendacionCursoDialogo5}
        textAlign="left"
        clase="responsiveEncuestaRecomendacion"
      ></DialogZegel>
    </div>
  )
}

export default EncuastaPrograma;